import './index.css';


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/locale-provider/style/css.js
// module id = 315
// module chunks = 0